const wellPlatformDisplayWindowMs = 4 * 60 * 60 * 1000;

function isDisplayableWellPlatform(stopId, platformKey, departureTimeMs, nowMs) {
  return (
    stopId === "WELL" &&
    Boolean(platformKey) &&
    Number.isFinite(departureTimeMs) &&
    departureTimeMs - nowMs <= wellPlatformDisplayWindowMs
  );
}

function getNormalizedPlatformKey(platformKey) {
  if (!platformKey) {
    return null;
  }

  return String(platformKey).replace(/^WELL/, "");
}

export function getDisplayPlatform(
  stopId,
  platform,
  departureTime,
  nowMs = Date.now(),
) {
  if (stopId !== "WELL") {
    return getNormalizedPlatformKey(platform);
  }

  const departureTimeMs = Date.parse(departureTime);

  if (!isDisplayableWellPlatform(stopId, platform, departureTimeMs, nowMs)) {
    return null;
  }

  return getNormalizedPlatformKey(platform);
}

export function getDisplayBoardingArea(
  stopId,
  { platform, pier } = {},
  departureTime,
  nowMs = Date.now(),
) {
  return getDisplayPlatform(stopId, pier ?? platform, departureTime, nowMs);
}

export function getDisplayPlatformKey(
  stopId,
  platformKey,
  aimed,
  expected,
  nowMs = Date.now(),
) {
  if (stopId !== "WELL") {
    return getNormalizedPlatformKey(platformKey);
  }

  const departureTimeMs = Date.parse(expected || aimed);

  if (!isDisplayableWellPlatform(stopId, platformKey, departureTimeMs, nowMs)) {
    return null;
  }

  return getNormalizedPlatformKey(platformKey);
}

export function getDisplayBoardingAreaKey(
  stopId,
  { platformKey, pierKey } = {},
  aimed,
  expected,
  nowMs = Date.now(),
) {
  return getDisplayPlatformKey(
    stopId,
    pierKey ?? platformKey,
    aimed,
    expected,
    nowMs,
  );
}

export function getBoardingAreaLabel(
  boardingAreaKey,
  { stopType, routeType, areaType } = {},
) {
  if (!boardingAreaKey) {
    return null;
  }

  const resolvedAreaType =
    areaType || getBoardingAreaType({ stopType, routeType });

  if (resolvedAreaType === "pier") {
    return `Pier ${boardingAreaKey}`;
  }

  if (resolvedAreaType === "stop") {
    return `Stop ${boardingAreaKey}`;
  }

  return `Platform ${boardingAreaKey}`;
}

export function getBoardingAreaType({ stopType, routeType, areaType } = {}) {
  if (areaType) {
    return areaType;
  }

  const isFerry =
    stopType === "ferry" ||
    String(routeType ?? "").trim() === "4" ||
    Number(routeType) === 4;

  if (isFerry) {
    return "pier";
  }

  const isBus =
    stopType === "bus" ||
    String(routeType ?? "").trim() === "3" ||
    Number(routeType) === 3;

  return isBus ? "stop" : "platform";
}
